import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  AccordionWrapper,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  AccordionSummary,
  Chevron,
} from './styles'

export const DefaultAccordion = ({ items, controlledIndex, onToggle }) => {
  const isControlled = controlledIndex !== undefined
  const [internalIndex, setInternalIndex] = useState(null)
  const activeIndex = isControlled ? controlledIndex : internalIndex

  const handleToggle = (index) => {
    const next = activeIndex === index ? null : index
    if (isControlled && onToggle) {
      onToggle(next)
    } else {
      setInternalIndex(next)
    }
  }

  if (!items || items.length === 0) return null

  return (
    <AccordionWrapper>
      {items.map((item, index) => {
        const expanded = activeIndex === index
        return (
          <AccordionItem key={`acc-item-${index}`}>
            <AccordionHeader
              type="button"
              onClick={() => handleToggle(index)}
              aria-expanded={expanded}
            >
              <span>
                <div>{item.title}</div>
                {item.summary && <AccordionSummary>{item.summary}</AccordionSummary>}
              </span>
              <Chevron $expanded={expanded}>{'\u25BC'}</Chevron>
            </AccordionHeader>
            <AccordionBody $expanded={expanded}>
              {expanded && item.children}
            </AccordionBody>
          </AccordionItem>
        )
      })}
    </AccordionWrapper>
  )
}

DefaultAccordion.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      summary: PropTypes.string,
      children: PropTypes.node,
    })
  ),
  controlledIndex: PropTypes.number,
  onToggle: PropTypes.func,
}

DefaultAccordion.defaultProps = {
  items: [],
}
